<table class="w-full">
  <thead>
    @if (!areAllPagesLoading()) {
      <tr>
        <th class="p-3" *hasPermission="['ORGANIZATION_FILE_DELETE']">
          <ui-checkbox
            [checked]="allSelected() === 'CHECKED'"
            [indeterminate]="allSelected() === 'INDETERMINATE'"
            (checkedChange)="onSelectAllChange($event)"
          />
        </th>
        <th class="px-2 py-3 text-on-surface-variant dark:text-on-surface-variant-darkmode">
          <ng-icon name="heroDocument" size="24" class="!block" />
        </th>
        <th class="p-3 text-sm font-semibold text-start leading-6">
          <button
            class="group flex items-center gap-2 cursor-pointer"
            (click)="onClickHeader('filename')"
          >
            {{ 'cockpit.documents.table.headerName' | transloco }}
            <span
              [ngClass]="
                orderBy() === 'filename'
                  ? 'p-0.5 flex-none rounded-sm text-on-surface dark:text-on-surface-darkmode bg-surface-variant dark:bg-surface-variant-darkmode group-hover:bg-surface-highlight dark:group-hover:bg-surface-highlight-darkmode'
                  : 'invisible p-0.5 flex-none rounded-sm text-on-surface-disabled dark:text-on-surface-disabled-darkmode group-hover:visible group-focus:visible'
              "
            >
              <ng-icon
                [name]="
                  orderBy() !== 'filename' || orderDirection() === 'desc'
                    ? 'heroChevronDown'
                    : 'heroChevronUp'
                "
                size="16"
                class="!block"
              />
            </span>
          </button>
        </th>
        <th class="hidden md:table-cell p-3 text-sm font-semibold text-start leading-6">
          <button
            class="group flex items-center gap-2 cursor-pointer"
            (click)="onClickHeader('fileType')"
          >
            {{ 'cockpit.documents.table.headerCategory' | transloco }}
            <span
              [ngClass]="
                orderBy() === 'fileType'
                  ? 'p-0.5 flex-none rounded-sm text-on-surface dark:text-on-surface-darkmode bg-surface-variant dark:bg-surface-variant-darkmode group-hover:bg-surface-highlight dark:group-hover:bg-surface-highlight-darkmode'
                  : 'invisible p-0.5 flex-none rounded-sm text-on-surface-disabled dark:text-on-surface-disabled-darkmode group-hover:visible group-focus:visible'
              "
            >
              <ng-icon
                [name]="
                  orderBy() !== 'fileType' || orderDirection() === 'desc'
                    ? 'heroChevronDown'
                    : 'heroChevronUp'
                "
                size="16"
                class="!block"
              />
            </span>
          </button>
        </th>
        <th class="hidden md:table-cell p-3 text-sm font-semibold text-start leading-6">
          <button
            class="group flex items-center gap-2 cursor-pointer"
            (click)="onClickHeader('createdAt')"
          >
            {{ 'cockpit.documents.table.headerUploadedAt' | transloco }}
            <span
              [ngClass]="
                orderBy() === 'createdAt'
                  ? 'p-0.5 flex-none rounded-sm text-on-surface dark:text-on-surface-darkmode bg-surface-variant dark:bg-surface-variant-darkmode group-hover:bg-surface-highlight dark:group-hover:bg-surface-highlight-darkmode'
                  : 'invisible p-0.5 flex-none rounded-sm text-on-surface-disabled dark:text-on-surface-disabled-darkmode group-hover:visible group-focus:visible'
              "
            >
              <ng-icon
                [name]="
                  orderBy() !== 'createdAt' || orderDirection() === 'desc'
                    ? 'heroChevronDown'
                    : 'heroChevronUp'
                "
                size="16"
                class="!block"
              />
            </span>
          </button>
        </th>
        <th class="hidden md:table-cell p-3 text-sm font-semibold text-start leading-6">
          <button
            class="group flex items-center gap-2 cursor-pointer"
            (click)="onClickHeader('sizeBytes')"
          >
            {{ 'cockpit.documents.table.headerFileSize' | transloco }}
            <span
              [ngClass]="
                orderBy() === 'sizeBytes'
                  ? 'p-0.5 flex-none rounded-sm text-on-surface dark:text-on-surface-darkmode bg-surface-variant dark:bg-surface-variant-darkmode group-hover:bg-surface-highlight dark:group-hover:bg-surface-highlight-darkmode'
                  : 'invisible p-0.5 flex-none rounded-sm text-on-surface-disabled dark:text-on-surface-disabled-darkmode group-hover:visible group-focus:visible'
              "
            >
              <ng-icon
                [name]="
                  orderBy() !== 'sizeBytes' || orderDirection() === 'desc'
                    ? 'heroChevronDown'
                    : 'heroChevronUp'
                "
                size="16"
                class="!block"
              />
            </span>
          </button>
        </th>
        <th class="hidden md:table-cell p-3"></th>
        <th class="p-3"></th>
      </tr>
    } @else {
      <ng-container *ngTemplateOutlet="placeholder" />
    }
  </thead>
  <tbody>
    @for (page of documents(); track page.page; let i = $index) {
      @if (page.isLoading) {
        @if (i === 0) {
          <ng-container *ngTemplateOutlet="placeholder" />
        } @else {
          @for (p of placeholders(); track $index) {
            <ng-container *ngTemplateOutlet="placeholder" />
          }
        }
      } @else if (page.error) {
        <tr>
          <td colspan="8" class="text-center">
            <app-error-page
              [error]="page.error"
              (clickBack)="router.navigate(['/organizations', organizationId()])"
              class="block"
              style="height: calc(100vh - 30rem)"
            />
          </td>
        </tr>
      } @else {
        @for (document of page.documents; track document.data.id) {
          <tr
            class="border-t border-outline dark:border-outline-darkmode"
            uiPopover
            [anchor]="optionsContextmenu"
            popoverEvent="contextmenu"
            [ngClass]="
              selectedRows()[document.data.id]
                ? 'bg-primary-soft/25 dark:bg-primary-soft-darkmode/25'
                : ''
            "
            [class.hidden]="document.isMarkedForDeletion"
          >
            <td class="p-3" *hasPermission="['ORGANIZATION_FILE_DELETE']">
              <ui-checkbox
                [checked]="selectedRows()[document.data.id]"
                (checkedChange)="onSelectRowChange(document.data.id, $event)"
              />
            </td>
            <td class="px-1 py-3 text-outline dark:text-outline-darkmode">
              <app-document-icon [file]="document.data" [size]="40" />
            </td>
            <td class="p-3 text-sm font-medium leading-6">
              {{ document.data | documentFilename }}
            </td>
            <td class="hidden md:table-cell p-3 text-sm font-normal leading-6">
              {{ document.data.fileType | documentFileType | transloco }}
            </td>
            <td class="hidden md:table-cell p-3 text-sm font-normal leading-6">
              {{ document.data.createdAt | date: 'dd.MM.yyyy' }}
            </td>
            <td class="hidden md:table-cell p-3 text-sm font-normal leading-6">
              {{ document.data.sizeBytes | fileSize }}
            </td>
            <td class="hidden md:table-cell p-3">
              <ui-button
                mode="ghost"
                [iconOnly]="true"
                (click)="onClickPreviewButton(document, previewDialog)"
                [uiTooltip]="'cockpit.documents.table.openPreview' | transloco"
                [attr.aria-label]="'cockpit.documents.table.openPreview' | transloco"
                class="block"
              >
                <ng-icon name="heroArrowTopRightOnSquare" size="20" class="!block" />
              </ui-button>
            </td>
            <td class="p-3 text-end">
              <ui-button
                uiPopover
                [anchor]="optionsDropdown"
                popoverEvent="click"
                mode="ghost"
                [iconOnly]="true"
                class="block"
              >
                <ng-icon name="heroEllipsisHorizontal" size="20" class="!block" />
              </ui-button>

              <ui-popover popover #optionsDropdown>
                <app-document-table-row-contextmenu
                  [document]="document.data"
                  [organizationId]="organizationId()"
                  (dismiss)="optionsDropdown.hide()"
                  (clickEdit)="openSelectedDocumentDialog(document, optionsDropdown, editDialog)"
                  (clickOpen)="openSelectedDocumentDialog(document, optionsDropdown, previewDialog)"
                  (clickShare)="openSelectedDocumentDialog(document, optionsDropdown, shareDialog)"
                  (clickDelete)="onClickDelete(document, optionsDropdown)"
                />
              </ui-popover>

              <ui-popover popover="manual" #optionsContextmenu>
                <app-document-table-row-contextmenu
                  [document]="document.data"
                  [organizationId]="organizationId()"
                  (dismiss)="optionsContextmenu.hide()"
                  (clickEdit)="openSelectedDocumentDialog(document, optionsContextmenu, editDialog)"
                  (clickOpen)="
                    openSelectedDocumentDialog(document, optionsContextmenu, previewDialog)
                  "
                  (clickShare)="
                    openSelectedDocumentDialog(document, optionsContextmenu, shareDialog)
                  "
                  (clickDelete)="onClickDelete(document, optionsContextmenu)"
                  uiClickOutside
                  (clickOutside)="optionsContextmenu.hide()"
                />
              </ui-popover>
            </td>
          </tr>
        }
      }
    }
  </tbody>

  @if (showLoadMorePlaceholders()) {
    <tbody
      appInViewport
      class="divide-y divide-outline bg-surface dark:divide-outline-darkmode dark:bg-surface-darkmode"
    >
      @for (p of placeholders(); track $index) {
        <ng-container *ngTemplateOutlet="placeholder" />
      }
    </tbody>
  }
</table>

<ng-template #placeholder>
  <tr>
    <td colspan="8" class="px-3 py-3.5">
      <ui-skeleton class="w-full h-[42px] block rounded-md" />
    </td>
  </tr>
</ng-template>

<ui-simple-dialog #editDialog [lazy]="true">
  @if (selectedDocument(); as doc) {
    <app-document-edit-dialog
      class="w-full block"
      [document]="doc.data"
      (clickCancel)="editDialog.close()"
      (updateSuccess)="onEditSuccess($event, editDialog)"
    />
  }
</ui-simple-dialog>

<ui-simple-dialog #previewDialog [lazy]="true" class="dialog-full">
  @if (selectedDocument(); as doc) {
    <app-document-preview-dialog
      class="w-full block"
      [document]="doc.data"
      [organizationID]="organizationId()"
      (clickCancel)="previewDialog.close()"
    />
  }
</ui-simple-dialog>

<ui-simple-dialog #shareDialog [lazy]="true">
  @if (selectedDocument(); as doc) {
    @if (shareDialog.isOpen()) {
      <app-document-share-dialog
        class="w-full block"
        [document]="doc.data"
        [organizationID]="organizationId()"
        (clickCancel)="shareDialog.close()"
      />
    }
  }
</ui-simple-dialog>
